/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../apimodel.d.ts" />
/// <reference path="../directives/validators/validatorbase.ts" />
/// <reference path="app.common.services.module.ts" />
/// <reference path="../directives/validators/ivalidator.d.ts" />
/// <reference path="../directives/validators/igroupvalidator.ts" />
/// <reference path="../iformscope.d.ts" />
/// <reference path="../controllers/iscreencontroller.d.ts" />
/// <reference path="modelstatevalidationservice.ts" />

module App.Common.Services {
    'use strict';

    export class ValidationErrorMessageResolverService {

        public standardErrorMessages: {[key: string]: string} = {};

        public validators: {[key: string]: Common.Directives.IValidator} = {};

        public groupValidators: {[key: string]: Common.Directives.IGroupValidator} = {};

        public static $inject = [
            '$q',
            'app.common.services.modelStateValidationService',
            'defaultErrorMessageResolver'
        ];

        constructor(
            private $q: angular.IQService,
            private modelStateValidation: Services.ModelStateValidationService,
            private defaultErrorMessageResolver: any) {
            defaultErrorMessageResolver.getErrorMessages()
                .then((errorMessages: any) => {
                    _.assign(errorMessages,
                        {
                            email: 'Please enter a valid email address',
                            minlength: 'Please enter at least {0} characters',
                            maxlength: 'You have entered more than the maximum {0} characters',
                            min: 'Please enter the minimum number of {0}',
                            max: 'Please enter the maximum number of {0}',
                            required: 'This field is required',
                            date: 'Please enter a valid date in the format dd/mm/yyyy',
                            pattern: 'Please ensure the entered information adheres to the pattern {0}',
                            number: 'Please enter a valid number',
                            url: 'Please enter a valid URL in the format http(s)://www.google.com',
                            parse: 'Please enter a valid date in the format dd/mm/yyyy'
                        });
                    this.standardErrorMessages = errorMessages;
                });
        }

        public registerValidator(validator: Common.Directives.IValidator): void {
            if (this.validators[validator.nameCamelCase()] || this.groupValidators[validator.nameCamelCase()]) {
                throw new Error(`Validation message resolver already registered for error type "${validator.nameCamelCase()}"`);
            }
            this.validators[validator.nameCamelCase()] = validator;
        }

        public registerGroupValidator(validator: Common.Directives.IGroupValidator): void {
            if (this.validators[validator.nameCamelCase()] || this.groupValidators[validator.nameCamelCase()]) {
                throw new Error(`Validation message resolver already registered for error type "${validator.nameCamelCase()}"`);
            }
            this.groupValidators[validator.nameCamelCase()] = validator;
        }

        public resolve = (errorType: string, el: angular.IAugmentedJQuery): angular.IPromise<string> => {

            const defer = this.$q.defer<string>();
            const validator = this.validators[errorType];
            const groupValidator = this.groupValidators[errorType];

            if (!validator && !groupValidator) {

                if (errorType === 'modelstate') {
                    defer.resolve(this.modelStateValidation.getErrorMessageForElement(el));
                    return defer.promise;
                } else if (errorType === 'mask') {
                    const attributeMessage = el.attr('ui-mask-message') || 'in the required format';
                    defer.resolve(`This field must be ${attributeMessage}`);
                    return defer.promise;
                } else if (this.standardErrorMessages[errorType]) {
                    defer.resolve(this.defaultErrorMessageResolver.resolve(errorType, el));
                    return defer.promise;
                } else {
                    throw(`No validator or standard error message registered for error type "${errorType}"`);
                }
            }

            if (validator) {
                defer.resolve(validator.resolveMessageForElement(el, errorType));
                return defer.promise;
            } else {
                defer.resolve(groupValidator.resolveMessageForElement(el, errorType));
                return defer.promise;
            }
        };
    }

    factory.$inject = ['$q', 'app.common.services.modelStateValidationService', 'defaultErrorMessageResolver'];

    function factory($q: angular.IQService,
        modelStateValidation: Services.ModelStateValidationService,
        defaultErrorMessageResolver: any) {
        return new ValidationErrorMessageResolverService($q, modelStateValidation, defaultErrorMessageResolver);
    }

    angular
        .module('app.common.services')
        .factory('app.common.services.validationErrorMessageResolverService', factory);
}